import { atom } from "jotai";
import { LeadsFetchDataParams } from "./components/CampaignsLeadsTable/CampaignsLeadsTable.types";

export const leadsHasResultsAtom = atom<boolean>(false);

export const downloadFetchDataParamsAtom = atom<
  Omit<LeadsFetchDataParams, "page" | "per_page"> | undefined
>(undefined);
